import { render, staticRenderFns } from "./MobileConsultingMessage.vue?vue&type=template&id=060cc674&scoped=true"
import script from "./MobileConsultingMessage.vue?vue&type=script&lang=js"
export * from "./MobileConsultingMessage.vue?vue&type=script&lang=js"
import style0 from "./MobileConsultingMessage.vue?vue&type=style&index=0&id=060cc674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060cc674",
  null
  
)

export default component.exports